import { apiAxios } from '../../../../helpers/api'
import queueToast from '../../../../helpers/queueToast'
import FormData from 'form-data'
import vuetifyToast from 'vuetify-toast'

export const setUpdate = async (one, url, type) => {
  const photo = one.img
  delete one.img
  const result = await apiAxios.put(url + one._id, one)
  queueToast(result.data.message.reason, 'success', 'warning')
  if (photo) {
    try {
      let resOne = result.data.data[type]
      await uploadFile(resOne, photo, url)
    } catch (error) {
      console.log('Error al subir archivo.')
    }
  }
  return result.data.data[type]
}
export const setDelete = async (id, url) => {
  const result = await apiAxios.delete(url + id)
  queueToast(result.data.message.reason, 'success', 'warning')
}
export const setCreate = async (one, url, type) => {
  const photo = one.img
  delete one.img
  const result = await apiAxios.post(url + 'create/', one)
  if (photo) {
    let resOne = result.data.data[type]
    uploadFile(resOne, photo, url)
  }
  queueToast(result.data.message.reason, 'success', 'warning')

  return result.data.data[type]
}

export const setRandomMatches = async (tournamentId, phaseId) => {
  const result = await apiAxios.post(
    'tournaments/' + tournamentId + '/setRandomMatches/' + phaseId
  )
  vuetifyToast.show({
    text: result.data.message.reason,
    color: 'success',
    timeout: 2000,
    icon: 'warning'
  })
  return result.data.data.tournament
}

const uploadFile = async function(one, photo, url) {
  let file = new FormData()
  file.append('file', photo)

  const result = await apiAxios.post('/upload/file', file, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
  one.img = result.data.data.file.filename
  await setUpdateWithPhoto(one, url)
  vuetifyToast.show({
    text: result.data.message.reason,
    color: 'success',
    timeout: 2000,
    icon: 'warning'
  })
}
const setUpdateWithPhoto = async (one, url) => {
  const result = await apiAxios.put(url + one._id, one)
  vuetifyToast.show({
    text: result.data.message.reason,
    color: 'success',
    timeout: 2000,
    icon: 'warning'
  })
}
